import { useConnections } from '../../hooks/useConnections';

export default function IncomingRequests() {
  const { pending, loading, respond } = useConnections();

  const handleRespond = async (id, status) => {
    try {
      await respond(id, status);
    } catch (err) {
      alert('Failed: ' + err.message);
    }
  };

  if (loading) return <div className="text-sm text-gray-400">Loading requests...</div>;

  if (pending.length === 0) {
    return (
      <div className="glass p-7">
        <h2 className="font-heading text-xl text-vault-navy mb-4">Incoming Pitch Requests</h2>
        <p className="text-sm text-gray-400">No pending requests.</p>
      </div>
    );
  }

  return (
    <div className="glass p-7">
      <h2 className="font-heading text-xl text-vault-navy mb-5">Incoming Pitch Requests</h2>
      <div className="space-y-4">
        {pending.map(conn => (
          <div key={conn.id} className="border border-vault-border rounded-btn p-5 flex items-start justify-between gap-4">
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-vault-navy text-sm">
                {conn.inventor?.display_name || 'Unknown Inventor'}
              </div>
              <div className="text-xs text-gray-400 mt-1">
                {conn.inventor?.email}
              </div>
              {conn.voucher && (
                <div className="mt-2 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-amber-50 border border-amber-200 text-amber-700 text-[11px] font-medium">
                  Vouched by {conn.voucher.company_name}
                </div>
              )}
              <div className="text-[11px] text-gray-400 mt-2">
                Requested {new Date(conn.requested_at).toLocaleDateString()}
              </div>
            </div>
            <div className="flex gap-2 shrink-0">
              <button
                onClick={() => handleRespond(conn.id, 'approved')}
                className="px-4 py-2 rounded-btn text-sm font-semibold text-white"
                style={{ background: 'linear-gradient(135deg, #c9a84c, #F59E0B)' }}
              >
                Accept
              </button>
              <button
                onClick={() => handleRespond(conn.id, 'declined')}
                className="px-4 py-2 rounded-btn text-sm font-semibold text-vault-error border border-vault-error/30 hover:bg-red-50"
              >
                Decline
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}